//#region src/bite_log_flash_event.ts
var BiteLogFlashEvent = /* @__PURE__ */ function(BiteLogFlashEvent) {
	BiteLogFlashEvent[BiteLogFlashEvent["SessionTokenInvalid"] = 1] = "SessionTokenInvalid";
	BiteLogFlashEvent[BiteLogFlashEvent["SessionTokenExpired"] = 2] = "SessionTokenExpired";
	return BiteLogFlashEvent;
}(BiteLogFlashEvent || {});
//#endregion
export { BiteLogFlashEvent };

//# sourceMappingURL=bite_log_flash_event.js.map